export const TITLE = "Last 7 Days";

export const DAYS_TO_SHOW = 8;
